/**
 * List/table search ignores the other filters (SFRESTO-108).
 *
 * The date range and the list filters (status, payment, type, table, method,
 * supplier...) scope plain browsing only. While the user types a search term,
 * all of them are dropped from the query, so a row is found whatever its
 * date or status, the same way the orders cards view (`useOrderFilters`)
 * already works. The filter controls keep their values, and clearing the
 * search brings the filtered list back.
 */

/** True when `term` holds something other than whitespace. */
export function isSearching(term: string | null | undefined): boolean {
  return (term ?? "").trim() !== "";
}

/**
 * Returns `filters` when there is no search term, else an empty object.
 * Spread the result into the list query next to the search term, paging and
 * sort params (which always apply).
 */
export function filtersUnlessSearching<T extends Record<string, unknown>>(
  term: string | null | undefined,
  filters: T
): T | Record<string, never> {
  return isSearching(term) ? {} : filters;
}
